// utils.js

export function findValueByKeyPath(obj, path) {
  return path
    .split('.')
    .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export function omitKeys(obj, keysToOmit) {
  return Object.keys(obj).reduce((acc, key) => {
    if (!keysToOmit.includes(key)) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}
